/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttachMediaDto } from '../../models/attach-media-dto';
import { BaseResponse } from '../../models/base-response';
import { EntityMediaItem } from '../../models/entity-media-item';

export interface EntityMediaControllerAttach$Params {
      body: AttachMediaDto
}

export function entityMediaControllerAttach(http: HttpClient, rootUrl: string, params: EntityMediaControllerAttach$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EntityMediaItem;
}>> {
  const rb = new RequestBuilder(rootUrl, entityMediaControllerAttach.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: EntityMediaItem;
      }>;
    })
  );
}

entityMediaControllerAttach.PATH = '/file-manager/attach';
